import MemoResearchItem from "./ResearchItem";
import { TYPO } from "styles/Typo";
import { useRouter } from "next/router";
import { useResearchInfiniteList } from "utils/hooks/ResearchInfinistList";
import { useParams } from "next/navigation";
import { useCallback, useRef, useState } from "react";
import useIsDetailLoading from "states/detailLoading";
import Button from "components/common/buttons/buttons";
import CustomToast from "components/atoms/CustomToast";
import {
  useIndustryMMTData,
  useRelatedIndustryData,
} from "utils/clientAPIs/detailDiagnosis";
import RequestDataTemp from "../RequestDataTemp";
import { postFetcher } from "utils/clientAPIs/fetcher";
import { useMutation } from "@tanstack/react-query";
import { useReportRequest } from "lib/analytics/react/hooks";
import { TrackedList } from "lib/analytics/react/list";
function DebateGeniusIndex({ detailData }: { detailData: any }) {
  const router = useRouter();

  const isLoading = useIsDetailLoading();
  const reportRequest = useReportRequest({
    ticker: detailData?.ITEM_CD_DL,
    market: detailData?.LOC,
  });

  const { ticker } = useParams();
  const {
    researchList,
    isLoadingInit,
    isLoadingMore,
    isReachingEnd,
    loadMore,
  } = useResearchInfiniteList({
    ticker: ticker as string,
  });

  // 산업 데이터 요청 - 관련 종목 리서치가 없을 때
  const [mmtData, isLoadingMMT] = useIndustryMMTData(
    ticker as string,
    detailData?.ITEM_CD,
    detailData?.ITEM_CD !== undefined &&
      (isLoadingInit || researchList?.length === 0),
    true
  );
  const tucds = mmtData?.industry.map((item: any) => item?.TU_CD);
  // 연관 산업으로 리포트 데이터 요청 - 관련 종목 리서치가 없을 때
  const [relatedIndustryData, isLoadingRelatedIndustry] =
    useRelatedIndustryData(
      ticker as string,
      tucds,
      isLoadingInit || researchList?.length === 0
    );

  //
  const observerRef = useRef<IntersectionObserver | null>(null);
  const observeLastItem = useCallback(
    (node: HTMLDivElement | null) => {
      if (isLoadingMore || isReachingEnd) return;
      if (observerRef?.current) observerRef.current.disconnect();

      observerRef.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          loadMore(); // 마지막 요소가 보이면 loadMore 실행
        }
      });

      if (node) observerRef.current.observe(node);
    },
    [isLoadingMore, isReachingEnd, loadMore]
  );

  {
    /**  Global Tab auto smooth scroll - 적당한 height이 필요 */
  }
  if (isLoading) return <div className="min-h-[100vh]"></div>;
  if (isLoadingInit || researchList?.length === 0) {
    return (
      <div style={{ minHeight: "calc(100vh - 200px)" }}>
        <RequestDataTemp
          isDisplay={true}
          subTitle="리포트가 궁금하시다면"
          title="작성을 요청해주세요"
          buttonText="요청하기"
          dataGtmId={"sDetail-debate-genius-request-button"}
          ticker={ticker as string}
          url={"/api/detail/report"}
          clickHandler={() => {
            console.log("clickHandler");
            reportRequest.start();
            localStorage.setItem(
              `debateGeniusRequest:${ticker}`,
              new Date().toISOString()
            );
          }}
          successHandler={() => {
            reportRequest.success();
          }}
          failHandler={() => {
            reportRequest.fail();
          }}
        />
        {relatedIndustryData?.data?.length > 0 && (
          <div className="w-full">
            <div className="pb-2 px-6 pt-6">
              <p className={`${TYPO.TYPO5_1_SB} text-gray90`}>
                {relatedIndustryData?.type === "nothing"
                  ? "전체 리포트"
                  : "관련 리포트"}
              </p>
            </div>
            <TrackedList
              listId="stock_feed_reporttab_list"
              totalCount={relatedIndustryData?.data?.length}
            >
              {relatedIndustryData?.data?.map((item: any, index: number) => (
                <MemoResearchItem key={index} data={item} index={index} />
              ))}
            </TrackedList>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="flex flex-col" style={{ minHeight: "calc(100vh - 200px)" }}>
      <p className={`${TYPO.TYPO5_1_SB} text-gray90 px-6 pt-5 pb-2`}>
        {`${
          router.locale === "ko"
            ? detailData?.ITEM_KR_NM
            : detailData?.ITEM_ENG_NM
        } 관련 AI 리포트`}
      </p>
      <div>
        <TrackedList
          listId="stock_feed_reporttab_list"
          totalCount={researchList?.length}
        >
          {researchList.map((item: any, index: number) => (
            <MemoResearchItem key={index} data={item} index={index} />
          ))}
        </TrackedList>
      </div>
      <div ref={observeLastItem} />
    </div>
  );
}

export default DebateGeniusIndex;
